import React, { FC, useMemo } from 'react';
import { ChevronDown, LucideIcon } from 'lucide-react';

import { GuestStatus } from 'types/guest.types';
import { Button } from 'epoch-ui/components/Button';
import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuContent
} from 'epoch-ui/components/DropdownMenu';

import { getDisplayTextForStatus, getIconForStatus } from '../../../utils';

interface SelectRsvpDropdownOption {
  status: GuestStatus;
  text: string;
  icon: LucideIcon;
}

const getRsvpDropdownOptionForStatus: (status: GuestStatus) => SelectRsvpDropdownOption = (
  status: GuestStatus
) => ({ text: getDisplayTextForStatus(status), icon: getIconForStatus(status), status });

export interface SelectRsvpDropdownProps {
  placeholder?: string;
  statusOptions: GuestStatus[];
  selectedStatus?: GuestStatus;
  onSelect: (status: GuestStatus) => void;
}

export const SelectRsvpDropdown: FC<SelectRsvpDropdownProps> = ({
  placeholder = 'Select',
  statusOptions,
  selectedStatus,
  onSelect
}) => {
  const dropdownOptions = useMemo(
    () => statusOptions.map(getRsvpDropdownOptionForStatus),
    [statusOptions]
  );
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className="tw-w-full tw-justify-between tw-rounded-[8px] tw-border-[1.5px] tw-border-solid tw-border-border-grey tw-bg-white tw-font-normal tw-text-black">
          <span>{selectedStatus ? getDisplayTextForStatus(selectedStatus) : placeholder}</span>
          <ChevronDown size={16} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="tw-w-full tw-min-w-[var(--radix-dropdown-menu-trigger-width)]">
        {dropdownOptions.map((option, index) => (
          <DropdownMenuItem key={index} onClick={(): void => onSelect(option.status)}>
            <div className="tw-flex tw-w-full tw-flex-row tw-items-center tw-justify-between tw-gap-2 [&_svg]:tw-h-4 [&_svg]:tw-w-4">
              <div className="tw-flex tw-items-center tw-gap-2">
                <option.icon />
                <div>{option.text}</div>
              </div>
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
